import * as React from "react";
import {
  FormControl,
  Typography,
  Box,
  TextField,
  Button,
  Checkbox,
} from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm as ReactHookForm, SubmitHandler } from "react-hook-form";
import { TermsCondition, PostalCode } from ".";
import { useForm, FormContextInterface } from "../context";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

type FormValues = {
  Address1: string;
  Address2: string;
  Town: string;
  Country: string;
  medicalSenNotes: string;
  applicationNotes: string;
  PostCode: string;
  TermsAndCondition: boolean;
  Consent: boolean;
};

const parentSchema = yup.object().shape({
  Address1: yup.string().required("First line address is required"),
  Address2: yup.string(),
  Town: yup.string().required("Town is required"),
  medicalSenNotes: yup.string(),
  PostCode: yup.string().required("Post code is required"),
  applicationNotes: yup.string(),
  Country: yup.string().required("Country is required"),
  Consent: yup.boolean(),
  TermsAndCondition: yup
    .boolean()
    .required(
      "You must read and accept the Terms and Conditions before submitting"
    ),
});

const Address = ({ move }: any) => {
  const [open, setOpen] = React.useState(false);
  const [TermsAndCondition, setTermsAndCondition] = React.useState(false);
  const [Consent, setConsent] = React.useState(true);
  const FocusAddressInput = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    setTimeout(() => {
      FocusAddressInput.current?.focus();
    }, 500);
  }, [move]);

  const {
    handleFormSubmit,
    address,
    setAddress,
    schoolInfo,
    handleSubmitLogActivity,
  } = useForm() as FormContextInterface;
  const [TCerror, setTCerror] = React.useState("");
  const addressclick = () => {
    handleSubmitLogActivity({
      ActivityType: "DetailSubmit",
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
  } = ReactHookForm<FormValues>({
    resolver: yupResolver(parentSchema),
    mode: "onSubmit",
    defaultValues: address,
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    if (TermsAndCondition) {
      data.TermsAndCondition = TermsAndCondition;
      data.Consent = Consent;
      handleFormSubmit(data);
    } else {
      setTCerror(
        "You must read and accept the Terms and Conditions before submitting."
      );
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    handleSubmitLogActivity({
      ActivityType: "T&CButton",
    });
  };

  const handleClose = () => {
    setOpen(false);
    handleSubmitLogActivity({
      ActivityType: "OkButton",
    });
  };

  React.useEffect(() => {
    return () => {
      setAddress(getValues());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmitAddress = (address: any) => {
    setValue("Address1", address.address1);
    setValue("Address2", address.address2);
    setValue("Country", address.country);
    setValue("Town", address.town);
    setValue("PostCode", address.postCode);
    setValue("TermsAndCondition", TermsAndCondition);
    setValue("Consent", Consent);
  };

  return (
    <Box id="address-details">
      {(schoolInfo?.signUpMethod == "School" &&
        schoolInfo?.schoolSignUp == true) ||
      schoolInfo?.signUpMethod == "MTech" ? (
        <>
          <Box paddingTop={3}>
            <Typography
              variant="h5"
              className="section_titles"
              mb={4}
              sx={{
                fontSize: "1.1rem !important",
                fontWeight: "bold !important",
              }}
            >
              Address & Additional Information
            </Typography>
            <PostalCode
              handleSubmitAddress={handleSubmitAddress}
              FocusAddressInput={FocusAddressInput}
            />
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl
                variant="outlined"
                fullWidth
                sx={{ "& > :not(style)": { my: 2 } }}
              >
                <TextField
                  id="standard-helperText"
                  className="custom-textfield"
                  variant="standard"
                  helperText={
                    errors.Address1 && (
                      <Box component={"span"} sx={{ color: "error.main" }}>
                        {errors?.Address1?.message}
                      </Box>
                    )
                  }
                  {...register("Address1")}
                  fullWidth
                  placeholder="First Line Address *"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="standard"
                  // label="Second Line Address"
                  {...register("Address2")}
                  fullWidth
                  placeholder="Second Line Address"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="standard"
                  // label="Town"
                  helperText={
                    errors.Town && (
                      <Box component={"span"} sx={{ color: "error.main" }}>
                        {errors?.Town?.message}
                      </Box>
                    )
                  }
                  {...register("Town")}
                  fullWidth
                  placeholder="Town *"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="standard"
                  // label="Country"
                  helperText={
                    errors.Country && (
                      <Box component={"span"} sx={{ color: "error.main" }}>
                        {errors?.Country?.message}
                      </Box>
                    )
                  }
                  {...register("Country")}
                  fullWidth
                  placeholder="Country *"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="standard"
                  // label="Country"
                  helperText={
                    errors.PostCode && (
                      <Box component={"span"} sx={{ color: "error.main" }}>
                        {errors?.PostCode?.message}
                      </Box>
                    )
                  }
                  {...register("PostCode")}
                  fullWidth
                  placeholder="Post Code *"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="outlined"
                  {...register("medicalSenNotes")}
                  fullWidth
                  placeholder="Vital Notes: Please confirm any relevant medical conditions or SEN information to ensure we provide appropriate support for your child."
                  multiline
                  rows={2}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <TextField
                  id="standard-helperText"
                  variant="outlined"
                  {...register("applicationNotes")}
                  fullWidth
                  placeholder="Application Notes: Any other useful info, e.g. your preferred day."
                  multiline
                  rows={2}
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      opacity: "1",
                    },
                  }}
                />

                <Typography variant="body1" textAlign={"justify"}>
                  <Checkbox
                    checked={Consent}
                    onChange={(e) => {
                      setConsent(e.target.checked);
                    }}
                    color="default"
                    sx={{ padding: 0 }}
                  />
                  We may photograph/video M:Tech classes in order to showcase
                  our course and our work with schools. If you do not consent to
                  including your child in this, please untick.
                </Typography>

                <Typography variant="body1" textAlign={"justify"}>
                  <Checkbox
                    checked={TermsAndCondition}
                    onChange={(e) => {
                      setTermsAndCondition(e.target.checked);
                    }}
                    color="default"
                    sx={{ padding: 0 }}
                  />
                  I have read, understood and accept the M:Tech &nbsp;
                  <a
                    href="#"
                    onClick={handleClickOpen}
                    style={{ color: "#ff00d0", fontSize: "16px" }}
                  >
                    Terms and Conditions
                  </a>
                  {!TermsAndCondition && (
                    <Typography variant="body1" color="error.main">
                      {TCerror}
                    </Typography>
                  )}
                </Typography>
              </FormControl>

              <br />
              <br />

              <Box display={"flex"} justifyContent="center">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ minWidth: 200 }}
                  style={{
                    background: "#ff00d0",
                    borderRadius: "10px",
                    fontWeight: "bold",
                  }}
                  onClick={addressclick}
                >
                  Submit
                </Button>
              </Box>
            </form>

            <Dialog open={open} onClose={handleClose} fullScreen={true}>
              <DialogContent style={{ background: "#ffffff" }}>
                <DialogContentText>
                  <TermsCondition />
                </DialogContentText>
              </DialogContent>
              <DialogActions
                style={{ background: "#ffffff", padding: "16px 30px 40px 0px" }}
              >
                <Button
                  id="okbtn"
                  onClick={handleClose}
                  autoFocus
                  style={{ color: "white", background: "rgb(255, 0, 208)" }}
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </>
      ) : (
        ""
      )}
    </Box>
  );
};

export { Address };
